module.exports = __webpack_public_path__ + "img/change.ffe93c97.svg";